export const getInitialThreadViewAsyncData = state => state.initialThreadView;